import * as React from 'react';

import {Checkbox} from '../../checkbox/checkbox';

import type {GroupConfigurationSetting} from './group-configuration-table';

type Props = {
    groupConfigurationSetting: GroupConfigurationSetting | null | undefined;
    isFixed?: boolean;
    onChange: (checked: boolean) => any;
};

export function ConfigurationCheckbox(props: Props) {
    const {groupConfigurationSetting, isFixed} = props;

    // If the setting itself is fixed, it retains it's original state (unlike isDisabled)
    // but should not be toggleable
    const fixedSetting = groupConfigurationSetting && groupConfigurationSetting.isFixed;

    return (
        <Checkbox
            // @ts-expect-error
            type='checkbox'
            checked={Boolean(groupConfigurationSetting && !groupConfigurationSetting.isDisabled)}
            disabled={groupConfigurationSetting && groupConfigurationSetting.isDisabled}
            onChange={isFixed || fixedSetting ? undefined : props.onChange}
            customCheckboxStyle={
                isFixed || fixedSetting ? {opacity: 0.4, pointerEvents: 'none'} : undefined
            }
        />
    );
}
